
<template>
  <div id="RefundChangeRule" v-bind="$attrs" v-on="$listeners">
    <el-tabs style="width: 500px; height: 400px; overflow: auto">
      <el-tab-pane label="退改签及行李">
        <div class="rule_item" v-if="sale.flightRemark">
            <div class="rule_title">
              {{ sale.flightRemark.split('-')[0] }}
            </div>
            <div class="rule_content tt-orange">
              {{ sale.flightRemark.split('-')[1] }}
            </div>
          </div>
        <div class="rule_item">
          <div class="rule_title">成人/儿童/婴儿</div>
          <div
            class="rule_content rule_table"
            v-for="(t, ti) in ticketRule"
            :key="t.id + ti"
          >
            <div class="airline-line">
              {{ getCityStr(t.airRoute.slice(0, 3)) }}
              <img src="~@img/airticket.png" alt="" />
              {{ getCityStr(t.airRoute.slice(3)) }}
              <span class="tt-orange">
                ({{
                  (flight.depart === t.airRoute.slice(0, 3)
                    ? parPrice - ((sale.transferPrice || {}).parPrice || 0)
                    : (sale.transferPrice||{}).parPrice)
                    | moneyNoPoint
                    | thousandBitSeparator
                }})
              </span>
            </div>
            <div class="rule_row">
              <div class="tt-t-c left">退票</div>
              <div class="right" v-html="getHtml(t.refundTicketDes, t)"></div>
            </div>
            <div class="rule_row">
              <div class="tt-t-c left">改签</div>
              <div class="right" v-html="getHtml(t.changeTicketDes, t)"></div>
            </div>
            <div class="rule_row">
              <div class="tt-t-c left">签转</div>
              <div class="right" v-html="getHtml(t.signTicketDes, t)"></div>
            </div>
            <div class="rule_row">
              <div class="tt-t-c left">行李额</div>
              <div
                class="right"
                v-html="baggage&&baggage[ti] ? getBaggage(ti) : '具体以航司为准'"
              ></div>
            </div>
          </div>
        </div>
        <div class="rule_item">
          <div class="rule_title">购买说明</div>
          <div class="rule_content">
            以上均为乘客自愿退改签规则，非自愿退改签规则以可适用法律及航空公司规定为准。
            以上退改签规则仅供参考，具体以各航空公司以及各航空公司官方网站的公式为准。<br /><br />
            折扣说明：经济舱折扣以标准经济舱全价为基础计算得出。<br /><br />
            申请改签，同舱位变更时，如变更前后的票面价之间存在差价，需补足差价；如同时存在改期手续费和升舱费，则需同时收起改期手续费和舱位差额。
          </div>
        </div>
        <div class="rule_item">
          <div class="rule_title">特殊说明</div>
          <div class="rule_content">
            保险说明：在订单填写页面可进行保险选购编辑
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="婴儿/儿童票">
        <div class="rule_item">
          <div class="rule_title">儿童票购买说明</div>
          <div class="rule_content">
            1.2岁（含）至12岁（不含）可购买儿童票<br />
            2.儿童票价=成人全价票（经济舱）*50%<br />
            3.儿童乘机需要成人陪同，一名成人最多携2名儿童<br />
            4.儿童需与成人购买同等舱位机票<br />
            5.无身份证儿童，证件类型可选身份证(填写户口簿身份证号)、护照<br />
          </div>
        </div>
        <div class="rule_item">
          <div class="rule_title">婴儿票购买说明</div>
          <div class="rule_content">
            1.14天（含）至2岁（不含）可购买婴儿票<br />
            2.婴儿票价=成人全价票（经济舱）*10%<br />
            3.婴儿乘机需要成人陪同，一名成人最多携2名婴儿<br />
            4.婴儿需与成人购买同等舱位机票<br />
            5.无身份证婴儿，证件类型可选身份证(填写户口簿身份证号)、护照<br />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'RefundChangeRule',
  data () {
    return {
      refundTicketDes: '',
      changeTicketDes: '',
      signTicketDes: '',
      baggage: {},
      parPrice: '',
      ticketRule: {},
      flight: {},
      cityList: [],
      sale: {}
    }
  },
  computed: {
    ...mapState(['indexStore']),
    obj () {
      return this.$attrs.obj
    }
  },
  watch: {
    obj: {
      handler (n) {
        if (n) {
          this.loadData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    const { airport } = this.indexStore
    this.cityList = airport.airportList
    this.loadData()
  },
  methods: {
    // 加载基础数据
    async loadData () {
      let cabin = this.obj.cabin || {}
      let sale = this.obj.sale || {}
      this.flight = this.obj.flight || {}
      this.sale = this.obj.sale || {}
      let ticketRule = cabin.ticketRule || {}
      this.ticketRule = ticketRule
      // this.refundTicketDes = ticketRule.refundTicketDes || '具体以航司为准'
      // this.changeTicketDes = ticketRule.changeTicketDes || '具体以航司为准'
      // this.signTicketDes = ticketRule.signTicketDes || '具体以航司为准'
      this.baggage = cabin.baggage
      this.parPrice = sale.parPrice
    },
    // 获取城市
    getCityStr (s) {
      let c = this.cityList.filter((cl) => cl.airportCode === s)[0] || {}
      return c.cityCName
    },
    getHtml (str, o) {
      let { airRoute } = o
      let d = airRoute.slice(0, 3)
      return str.replace(/\n/g, '<br/>').replace(/\d+%/g, (f) => {
        return `<span class='tt-red'>¥${
          (f.split('%')[0] *
            (this.flight.depart === d
              ? this.parPrice - ((this.sale.transferPrice || {}).parPrice || 0)
              : this.sale.transferPrice.parPrice)) /
          100
        }</span>(${f})`
      })
    },
    getBaggage (i) {
      return `免费托运行李额：${this.baggage[i].bagAllow}KG<br>备注：${this.baggage[i].remark}`
    }
  }
}
</script>
<style lang="less" scoped>
.rule_item {
  padding: 5px 10px;
  .rule_title {
    line-height: 40px;
    font-size: 20px;
  }
  .rule_content {
    color: #84888f;
    .airline-line {
      color: #333;
      font-weight: 600;
      margin-right: 16px;
      display: flex;
      align-items: center;
      margin: 20px 0 10px;
      img {
        margin: 0 10px;
        width: 20px;
        height: 20px;
      }
    }
    &.rule_table {
      background-color: #fff;
      color: #84888f;
      border-bottom: 1px solid #dcdcde;
      .rule_row {
        display: flex;
        align-items: center;
        border: 1px solid #dcdcde;
        border-bottom: 0;
        .tt-t-c {
          text-align: center;
        }
        .left {
          padding: 0 20px;
          width: 40px;
          white-space: nowrap;
        }
        .right {
          border-left: 1px solid #dcdcde;
          padding: 5px 0 5px 10px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RefundChangeRule.vue